import { render, staticRenderFns } from "./amt_basic.vue?vue&type=template&id=56ff9a4c&scoped=true"
import script from "./amt_basic.vue?vue&type=script&lang=js"
export * from "./amt_basic.vue?vue&type=script&lang=js"
import style0 from "./amt_basic.vue?vue&type=style&index=0&id=56ff9a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff9a4c",
  null
  
)

export default component.exports